import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Switch,
} from "@mui/material";
import React, { useState } from "react";
import { Link, useLoaderData, useNavigate } from "react-router-dom";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
// import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AddIcon from "@mui/icons-material/Add";
import SyncIcon from "@mui/icons-material/Sync";

import UserManagementService from "../../../../../infrastructure/api/userManagement";
import DeleteConfirm from "../../../../components/shared/Dialog/DeleteConfirm";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";

const CustomerModulesPage = () => {
  const customerList = useLoaderData("root");
  let navigate = useNavigate();
  const [deleteConfirm, setDeleteConfirm] = useState({
    open: false,
    data: {},
  });
  const [cascadeDelete, setCascadeDelete] = useState(false);
  const headCells = [
    {
      id: "id",
      disablePadding: false,
      label: "ایدی",
    },
    {
      id: "firstName",
      disablePadding: false,
      label: "عنوان",
    },
    {
      id: "updateOn",
      type: "date",
      disablePadding: true,
      label: "تاریخ بروزرسانی",
    },
     
  ];

  const onEditClicked = (row) => {
    navigate(`${row.id}`);
  };

  const onDeleteClicked = (row) => {
    console.log("row", row);

    setDeleteConfirm((old) => ({ ...old, open: true, data: row }));
  };

  const confirmedDeleteCustomerModules = () => {
    console.log("cascadeDelete", cascadeDelete);
    return UserManagementService.deleteCustomerModulesApi({
      id: deleteConfirm.data.roleId,
      cascadeDelete,
    });
  };

  const onFetchData = () => {
    navigate();
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />

        <DeleteConfirm
          message={`برای حذف دیتای "${deleteConfirm.data.roleName}" اطمینان دارید؟`}
          open={deleteConfirm.open}
          onClose={(loadAgain) => {
            setDeleteConfirm({
              open: false,
              data: {},
            });
            setCascadeDelete(false);
            if (loadAgain) {
              navigate();
            }
          }}
          onSubmit={confirmedDeleteCustomerModules}
        >
          <Grid
            item
            xs={12}
            md={12}
            container
            justifyContent={"center"}
            sx={{ my: 1 }}
          >
            <FormControlLabel
              name="cascadeDelete"
              checked={cascadeDelete}
              onChange={(event) => {
                setCascadeDelete(event.target.checked);
              }}
              control={<Switch color="info" />}
              label="حذف کاربران زیرمجموعه این گروه"
            />
          </Grid>
        </DeleteConfirm>
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title="گروه کاربری"
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <Link to={"create"}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                  >
                    ایجاد
                  </Button>
                </Link>

                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  sx={{ mx: 1 }}
                />

                <IconButton
                  variant="text"
                  color="primary"
                  onClick={onFetchData}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />

          <CardContent>
            <Grid container>
              <Grid item xs={12} md={12}>
                <EnhancedTable
                  rowKey={"id"}
                  rows={customerList}
                  headCells={headCells}
                  pageSize={100}
                  actions={[
                    {
                      icon: <EditIcon sx={{ width: "1rem", height: "1rem" }} />,
                      onClick: onEditClicked,
                      color: "primary",
                    },
                    {
                      icon: (
                        <DeleteIcon sx={{ width: "1rem", height: "1rem" }} />
                      ),
                      onClick: onDeleteClicked,
                      color: "secondary",
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CustomerModulesPage;
